import { ConstConfig } from '@/constants'

const QNImageUtil = {
  /**
   * 七牛图片格式化，参考：https://developer.qiniu.com/dora/1279/basic-processing-images-imageview2
   * @param {string} hash
   * @param {number} w
   * @param {number} h
   * @param {number} mode, 0 1 2 3 4 5
   * @param {string} format
   * @returns {string}
   */
  imageView: (hash, w, h, mode = 1, format = '') => {
    mode = mode || (mode === 0 ? 0 : 1)
    hash = hash || ''
    let url = ''
    // if (!hash) return ''
    if (!hash.match(/^(http|https):/i)) {
      url = ConstConfig.qiniuCdn + '/' + hash
    } else {
      const start = hash.indexOf('images.banmabang.cn')
      if (start > -1) {
        hash = hash.replace('images.banmabang.cn', 'images.snsports.cn')
      }
      url = hash
    }
    w = w || 0
    h = h || 0
    if (url.match(/images\.snsports\.cn/i) || url.match(/live\.snsports\.cn/i) || url.match(/live\.banmabang\.cn/i)) {
      if (url.indexOf('?') < 0) {
        if (mode == 0) {
            url = url + '?imageView2/' + mode
            if (w > 0) {
                url += '/w/' + w
            }
            if (h > 0) {
                url += '/h/' + h
            }
        }
        else {
            url = url + '?imageView2/' + mode + '/w/' + w + '/h/' + h
        }
        if (format) {
          url += '/format/' + format
          if (format === 'jpg') {
            url += '/interlace/1'
          }
        }
      }
    }
    return url
  },
  /**
   * @param {string} hash
   * @param {number} size, width and height equal
   * @param {number} mode, 0 1 2 3 4 5
   * @param {string} format
   * @returns {string}
   */
  iconView: (hash, size, mode, format) => {
    return QNImageUtil.imageView(hash, size, size, mode, format)
  },
  /**
   * @param {string} hash
   * @returns {string}
   */
  originView: hash => {
    let url = ''
    if (!hash) return ''
    if (!hash.match(/^(http|https):/i)) {
      url = ConstConfig.qiniuCdn + '/' + hash
    } else {
      url = hash
    }
    return url
  },
  coachImageView: hash => {
    let url = ''
    if (!hash) return ''
    if (!hash.match(/^(http|https):/i)) {
      url = ConstConfig.outCoachCdn + '/' + hash
    } else {
      url = hash
    }
    return url
  },
  placeHolderImage: (w, h, font) => {
    return `https://placehold.it/${w}x${h}/828DFA/fff.png?text=${font}`
  }
}

export { QNImageUtil }
